module.exports = __webpack_public_path__ + "img/historyImg5.ecff87fb.jpg";